module.exports = __webpack_public_path__ + "static/img/4.197315c2.png";